<template>
  <section>
    <div class="workarea">
      <div class="ui-wood-block-chiseling" :class="{'animate': isAnimate }"></div>
      <div class="tool tool--combo" :class="{'animate': isAnimate }">
        <div class="tool tool--chisel"></div>
        <div class="tool tool--mallet"></div>
      </div>
    </div>
  </section>
</template>

<script>

export default {
  name: 'scene4animation',
  data: function () {
    return {
      isAnimate: false,
    }
  },
  methods: {
    animate() {
      this.isAnimate = !this.isAnimate;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "style";

.workarea {
  position: relative;
  width: 100%;
  height: 100%;
  flex: 0 0 auto;
  width: fluid(256px);
  height: fluid(251px);

  // preload images (https://stackoverflow.com/questions/1373142/preloading-css-images)
  &:after {
    position: absolute;
    width: 0;
    height: 0;
    overflow: hidden;
    z-index: -1;
    content: url('~@/assets/img/wood-block--chisel--before.svg')
      url('~@/assets/img/wood-block--chisel--step1.svg')
      url('~@/assets/img/wood-block--chisel--step2.svg')
      url('~@/assets/img/wood-block--chisel--after.svg');
  }
}

.tool--combo {
  position: absolute;
  cursor: auto;
  opacity: 0;

  &.animate {
    animation-name: chisel-mallet;
    animation-duration: 5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;

    .tool--mallet {
      animation-name: mallet-hit;
      animation-duration: 5s;
      animation-iteration-count: 1;
      animation-fill-mode: forwards;
    }
  }

  .tool--chisel {
    transform: rotate(90deg);
    cursor: auto;
  }

  .tool--mallet {
    margin-top: fluid(-24px);
    transform: rotate(15deg);
    cursor: auto;
  }
}

.ui-wood-block-chiseling {
  background-image: none;
  background-repeat: no-repeat;
  background-size: 90%;
  background-position: center center;
  position: absolute;
  width: 100%;
  height: 100%;
  background-image: url('~@/assets/img/wood-block--chisel--before.svg');

  &.animate {
    animation-name: wood-block-chipping;
    animation-duration: 5s;
    animation-iteration-count: 1;
    animation-fill-mode: forwards;
  }
}

@keyframes mallet-hit {
  24% { transform: rotate(15deg) }
  25% { transform: rotate(0deg) }
  26% { transform: rotate(15deg) }
  32% { transform: rotate(15deg) }
  33% { transform: rotate(0deg) }
  34% { transform: rotate(15deg) }
  65% { transform: rotate(15deg) }
  66% { transform: rotate(0deg) }
  67% { transform: rotate(15deg) }
}

@keyframes chisel-mallet {
  0% {
    top: 0;
    left: 0;
    opacity: 1;
  }

  25% {
    top: 5%;
    left: 86%;
    opacity: 1;
  }

  33% {
    top: 5%;
    left: 10%;
    opacity: 1;
  }
  66% {
    top: 50%;
    left: 15%;
    opacity: 1;
  }
  100% {
    top: 50%;
    left: 15%;
    opacity: 0;
  }
}

@keyframes wood-block-chipping {
  0% {
    background-image: url('~@/assets/img/wood-block--chisel--before.svg');
  }
  25% {
    background-image: url('~@/assets/img/wood-block--chisel--before.svg');
  }
  33% {
    background-image: url('~@/assets/img/wood-block--chisel--step1.svg');
  }
  66% {
    background-image: url('~@/assets/img/wood-block--chisel--step2.svg');
  }
  100% {
    background-image: url('~@/assets/img/wood-block--chisel--after.svg');
  }
}

</style>
